import { format, parse } from 'date-fns';

/** format a JS Date for the Network Insights API ('YYY-MM-DD')
 * @param date: Date the date object to format
 * @returns string the date formatted as 'YYYY-MM-DD'
 */
export const formatDateForApi = (date: Date): string => {
    return format(date, 'yyyy-MM-dd');
};

/**
 * Convert an API date to a JS Date object
 * Without this function, some dates will show up as a day earlier, due to timezone differences.
 * @param date string string representation of a date as stored in redux (yyyy-mm-dd)
 */
export const apiDateToLocalDate = (date: string): Date => {
    /** If we pass a date only string to the date value, we get a date in UTC, not local time, so append this whenever we create a new date */
    return parse(date, 'yyyy-MM-dd', new Date());
};
